import base64 from "base-64";
import cookies from "js-cookie";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import utf8 from "utf8";

import { setUserData } from "../components/appData.slice";

const decodeCookie = (val: string) => {
  try {
    const bytes = base64.decode(val);
    const decodedVal = utf8.decode(bytes);

    return JSON.parse(decodedVal);
  } catch (e) {
    return {
      login: "",
      name: "",
      surname: "",
    };
  }
};

export const useUserAuthentication = (): void => {
  const dispatch = useDispatch();
  const cookie = cookies.get("UserId");

  useEffect(() => {
    if (cookie) {
      const parsedCookie = decodeCookie(cookie);

      dispatch(
        setUserData({
          login: parsedCookie?.login || "",
          name: parsedCookie?.name || "",
          surname: parsedCookie?.surname || "",
        })
      );
    }
  }, [cookie, dispatch]);
};
